module.exports = __webpack_public_path__ + "img/364.e39020a4.jpg";